import { HTMLProps, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './SidebarSectionHeader.module.css';

export type SidebarSectionHeaderProps = HTMLProps<HTMLDivElement>;

const SidebarSectionHeader = forwardRef<
  HTMLDivElement,
  SidebarSectionHeaderProps
>((props, ref) => {
  const { className, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(className, styles.root)} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionHeader.displayName = 'SidebarSection.Header';

export default SidebarSectionHeader;
